import { cdnImageUrl, type CdnResizeOptions } from '@platform/media';

/**
 * 품셈 도해 주소 조립. 도움말(`docsAsset.ts`)과 같은 규약이다.
 *
 * 두 출처를 모두 받는다:
 *  1. **절대 URL** — 관리 화면에서 올린 파일. media-service 가 완성된 CDN URL 을
 *     돌려주므로 손대지 않는다.
 *  2. **상대 키** — CDN 의 `pumsem/` 아래 파일. prefix 를 붙인다.
 *
 * 구분하지 않으면 업로드한 이미지에 `pumsem/` 이 덧붙어 전부 404 가 된다.
 */
const PUMSEM_PREFIX = 'pumsem';

const isAbsolute = (src: string): boolean => /^https?:\/\//i.test(src);

export const pumsemImageUrl = (
  key: string,
  opts?: CdnResizeOptions,
): string =>
  isAbsolute(key) ? key : cdnImageUrl(`${PUMSEM_PREFIX}/${key}`, opts);
